import './i18n'
import { useTranslation } from 'react-i18next'
import SearchForm from './components/search/SearchForm'

function App({
  lang,
  partner,
  origin,
  destination,
  departureDate,
  returnDate,
  tripType,
  affilaeId,
}) {
  const { i18n } = useTranslation()
  if (lang && lang !== i18n.language) {
    i18n.changeLanguage(lang)
  }

  return (
    <SearchForm
      partner={partner}
      origin={origin}
      destination={destination}
      departureDate={departureDate}
      returnDate={returnDate}
      affilaeId={affilaeId}
      tripType={tripType || 'roundtrip'}
    />
  )
}

export default App
